const FALLBACK = "en";
// Resolve a LocalizedText to a concrete string for the given language.
// - string → returned as-is (single-language source: inline, staged, EN-only)
// - object → returns lang, then lang's primary subtag (sv-SE → sv), then
//   "en", then the first available, then ""
export function pickLocalized(text, lang, fallback = FALLBACK) {
    if (typeof text === "string")
        return text;
    if (lang && text[lang] != null && text[lang] !== "")
        return text[lang];
    // Browsers/devices typically report region-qualified locales (sv-SE,
    // en-US). Translation keys are stored under bare primary subtags, so
    // strip the region and retry before falling through to English.
    const primary = lang ? lang.split("-")[0] : null;
    if (primary && primary !== lang && text[primary] != null && text[primary] !== "") {
        return text[primary];
    }
    if (text[fallback] != null && text[fallback] !== "")
        return text[fallback];
    for (const key of Object.keys(text)) {
        const v = text[key];
        if (v)
            return v;
    }
    return "";
}
// What languages does this text actually carry?
// - string → ["en"] (assume the canonical fallback)
// - object → keys with non-empty values
export function availableLanguages(text) {
    if (typeof text === "string")
        return [FALLBACK];
    return Object.keys(text).filter((k) => text[k]);
}
// Intersection of every question's available languages — i.e. the languages
// in which the whole quiz is renderable end-to-end. Useful for the host
// review screen when deciding which langs to advertise to students.
export function quizLanguages(texts) {
    let common = null;
    for (const t of texts) {
        const langs = new Set(availableLanguages(t));
        if (common === null) {
            common = langs;
        }
        else {
            for (const k of [...common])
                if (!langs.has(k))
                    common.delete(k);
        }
    }
    return common ? [...common] : [FALLBACK];
}
//# sourceMappingURL=localization.js.map